// extracted by mini-css-extract-plugin
export var mapWrapper = "styles-module--mapWrapper--w1f64";
export var marker = "styles-module--marker--H1dtQ";
export var bestsellerMarker = "styles-module--bestsellerMarker--ise80";
export var bestsellerImg = "styles-module--bestsellerImg--Cr1tN";
export var tabs = "styles-module--tabs--wVZ9b";
export var tabItem = "styles-module--tabItem--4wZJQ";
export var tabItemActive = "styles-module--tabItemActive--fDOlL";
export var tabActive = "styles-module--tabActive--9eEJf";
export var cluster = "styles-module--cluster--1uNu6";